import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
} from "@mui/material";
import { baseFontStyle, menuItemTextStyle } from "../../tickets/tickets";
import { INVALID_REASONS } from "../constants/ticketConstants";

const InvalidReason = (props) => {
  const {
    invalidDialog,
    closeInvalidDialog,
    handleInvalidReasonChange,
    handleInvalidSubmit,
  } = props;
  return (
    <Dialog
      open={invalidDialog.open}
      onClose={closeInvalidDialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          ...baseFontStyle,
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        Invalidate Ticket
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <FormControl fullWidth>
            <InputLabel sx={menuItemTextStyle}>Reason</InputLabel>

            <Select
              value={invalidDialog.reason}
              label="Reason"
              onChange={(e) => handleInvalidReasonChange(e, "reason")}
              sx={{
                "& .MuiSelect-select": {
                  ...menuItemTextStyle,
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      ...menuItemTextStyle,
                    },
                  },
                },
              }}
            >
              {INVALID_REASONS.map((reason) => (
                <MenuItem key={reason} value={reason} sx={menuItemTextStyle}>
                  {reason}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            required
            label="Comments"
            multiline
            rows={3}
            sx={{
              mt: 2,
              "& .MuiInputLabel-root": menuItemTextStyle,
              "& .MuiInputBase-input": menuItemTextStyle,
            }}
            value={invalidDialog.othersReason}
            onChange={(e) => handleInvalidReasonChange(e, "othersReason")}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
          onClick={closeInvalidDialog}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
          onClick={handleInvalidSubmit}
          disabled={!invalidDialog.reason || !invalidDialog.othersReason.trim()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidReason;
